import React, { Fragment } from "react";
import MetaTags from "react-meta-tags";
import { Link } from "react-router-dom";
import LayoutOne from "../layouts/LayoutOne";
import SectionHeroBanner from "../components/Common/SectionHeroBanner";
import MainTitle from "../components/Common/MainTitle";
import SectionPartner from "../components/Home/SectionPartner";

const ClientsPartners = () => (
  <Fragment>
    <MetaTags>
      <title>Clients & Partners | South Asia Consultancy</title>
      <meta
        name="description"
        content="Trusted by leading energy operators. Client logos, testimonials, and industries served by South Asia Consultancy."
      />
    </MetaTags>
    <LayoutOne>
      <SectionHeroBanner title="Clients & Partners" className="sectionGalleryBg" />
      <div className="container py-5 sac-page-shell">
        <MainTitle text="Proof in the Field" className="text-center" position="center" width="180px" />
        <p className="text-center fs18px fw500 mb-4 sac-intro">
          Long-term relationships with operators and service companies keep our crews sharp, compliant, and ready for campaign peaks.
        </p>
        <p className="text-center mb-5">
          <Link to="/industries" className="color-primary fw600">
            Industries we support
          </Link>
          <span className="mx-2">|</span>
          <Link to="/gallery" className="color-primary fw600">
            Operations gallery
          </Link>
        </p>
      </div>
      <SectionPartner />
      <div className="container py-5 sac-page-shell">
        <MainTitle text="Testimonials" className="text-center" position="center" width="140px" />
        <p className="text-center fs16px mt-3">
          Client quotes and formal references can be featured here. Connect with our BD team to publish approved statements.
        </p>
      </div>
    </LayoutOne>
  </Fragment>
);

export default ClientsPartners;
